import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDetalleCargaBuque } from '../../actions/controlDiario'
import DetalleDeCargaDeBuqueView from '../../components/listados/controlDiario/DetalleDeCargaDeBuqueView'

function DetalleCargaBuque (props) {
  const { detalle, actualizarDetalleCargaBuque } = props

  useEffect(() => {
    actualizarDetalleCargaBuque(detalle.fechaDeTurnoDeTrabajo, detalle.exportador, detalle.cereal, detalle.buque)
  }, [actualizarDetalleCargaBuque, detalle])

  return (
    <DetalleDeCargaDeBuqueView />
  )
}

const mapActionsToProps = {
  actualizarDetalleCargaBuque
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DetalleCargaBuque)
